<template>
  <ContentPage>
    <template #header>
      <Progress step="5" :steps="5">
        <h2 class="py-1" style="line-height: 28px;">
          What is your coverage area?
        </h2>
        <div class="my-2 mx-6" style="font-size: 14px">
          We will use your business address and driving distance to determine which leads are within your coverage area. 
        </div>
      </Progress>
    </template>

    <v-form ref="form" autocomplete="off">
      <v-container class="rounded-lg white">
        <v-row>
          <v-col cols="12">
            <simple-google-autocomplete
              id="theGAC"
              v-model="address_string"
              outlined dense persistent-placeholder hide-details clearable
              autocomplete="theGAC_fields"
              label="Business"
              @placechanged="updateAddressData"
              country="us"
              :rules="[required]"
            />
          </v-col>
          <v-col cols="12" class="pt-0">
            <l-map style="height: 220px" :zoom="zoom" :center="center">
              <l-tile-layer :url="url" :attribution="attribution" />
              <l-marker :lat-lng="center" />
              <l-circle :lat-lng="center" :radius="radius" color="green" />
            </l-map>
          </v-col>

          <v-col cols="12" class="py-0">
            <CoverageAreaSelect 
              outlined dense persistent-placeholder
              label="Coverage Area (miles)" 
              v-model="coverage_radius" persistent-hint
              hint="How far will you drive for a customer?"
              autocomplete="coverage_area"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <template #footer>
      <div class="d-flex justify-center py-2 rounded-lg white">
        <v-btn @click="backClick">Back</v-btn>
        <v-btn color="primary" class="ml-4" @click="nextClick">Done</v-btn>
      </div>
    </template>
  </ContentPage>
</template>

<script>
  import { ContentPage } from '@/components/pages'
  import Progress from './progress'
  import { CoverageAreaSelect }  from '@/components/inputs'
  import { required } from '@/lib/validations'
  import { mapActions, mapGetters } from 'vuex'
  import { latLng } from "leaflet"
  import { LCircle, LMarker, LMap, LTileLayer } from 'vue2-leaflet'

  export default {
    name: "WizardStepD",

    components: { ContentPage, Progress, CoverageAreaSelect, LCircle, LMarker, LMap, LTileLayer },

    data() {
      return {
        zoom: 8,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

        address_string: '',

        place_id: '',
        latitude: 30.2672,
        longitude: -97.7431,
        street: '',
        city: '',
        state: '',
        zipcode: '',
        coverage_radius: 20,

        // validation rules
        required,
      }
    },

    computed: {
      ...mapGetters('auth', ['me']),

      center() {
        return latLng(this.latitude, this.longitude)
      },

      radius() { 
        // in meters
        return this.coverage_radius * 1609.34
      },

      random_id() {
        return 'gac-id-' +  Math.floor(Math.random() * 100000)
      }
    },

    watch: {
      me(newMe) {
        this.setMe(newMe)
      },
    },

    methods: {
      ...mapActions('auth', ['loadMe', 'updateMe']),

      updateAddressData(addressData) {          
          this.place_id = addressData.place_id
          this.latitude = addressData.latitude
          this.longitude = addressData.longitude
          this.street = addressData.name
          this.city = addressData.locality
          this.state = addressData.administrative_area_level_1
          this.zipcode = addressData.postal_code
      },

      backClick() {
        this.$router.replace( { name: 'wizardD' } )
      },

      async nextClick() {
        if (this.$refs.form.validate()) {
          const payload = {
            address: {
              place_id: this.place_id,
              coords: `POINT(${this.longitude} ${this.latitude})`,
              street: this.street,
              city: this.city,
              state: this.state,
              zipcode: this.zipcode,
            },
            coverage_radius: this.coverage_radius,
            setup_complete: true,
          }

          const result = await this.updateMe(payload)
          if (result.ok) {
            this.$router.replace( { name: 'wizard/confirm' } )
          } else {
            this.error_dialog = true
            this.error_message = result.error
          }
        }
      },

      setMe(newMe) {
        this.address_string = `${ newMe.address.street }, ${ newMe.address.city }, ${ newMe.address.state }, ${ newMe.address.zipcode }`
        
        this.place_id = newMe.place_id
        this.latitude = newMe.address.latitude || this.latitude
        this.longitude = newMe.address.longitude || this.longitude
        this.street = newMe.address.street
        this.city = newMe.address.city
        this.state = newMe.address.state
        this.zipcode = newMe.address.zipcode

        this.coverage_radius = newMe.coverage_radius
      },
    },

    created() {
      this.setMe(this.me)
      this.loadMe()
    }
  }
</script>